<template>
  <v-container>
    <h3 class="font-weight-bold text--secondary mx-2 mb-4">
      Datos del empleado
    </h3>

    <v-card outlined>
      <v-card-title>
        <v-row class="justify-space-between align-center px-2">
          <h5 class="text--secondary">{{ datosEmpleadoCard.nombreCompleto }}</h5>

          <v-chip class="red--text" v-if="datosEmpleadoCard.Bloqueado" outlined>
            Bloqueado por Cartera
          </v-chip>
        </v-row>
      </v-card-title>

      <v-divider />
      <v-card-text class="py-2">
        <v-row class="py-0 flex-wrap">
          <v-col cols="12" sm="4">
            <span class="font-weight-bold text--secondary">
              Empresa:
              <span class="font-weight-regular">
                {{ datosEmpleadoCard.DescCompañia }}
              </span>
            </span>
          </v-col>

          <v-col cols="12" sm="4">
            <span class="font-weight-bold text--secondary">
              Tipo de contrato:
              <span class="font-weight-regular">
                {{ datosEmpleadoCard.DescTipoContrato }}
              </span>
            </span>
          </v-col>

          <v-col cols="12" sm="4">
            <span class="font-weight-bold text--secondary">
              Fecha de ingreso:
              <span class="font-weight-regular">
                {{
                  moment
                    .utc(datosEmpleadoCard.FechaIngreso)
                    .format('YYYY-MM-DD')
                }}
              </span>
            </span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'DatosEmpleadoCard',

  props: {
    datosEmpleadoCard: {
      type: Object,
      required: true,
    },
  },
};
</script>
